import { useQuery } from "@tanstack/react-query";

import { userStorage } from "@/lib/storage/user";
import { apiUser } from "@/services/api-client/user";
import { useAuthStore } from "@/store/auth.store";

import { userKeys } from "./user.keys";

export const useGetMe = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return useQuery({
    queryKey: userKeys.me(),
    queryFn: async () => {
      const user = await apiUser.getUser();
      userStorage.set(user);
      return user;
    },
    enabled: isAuthenticated,
    placeholderData: () => userStorage.get() ?? undefined,
  });
};
